import { render, staticRenderFns } from "./PostPaid.vue?vue&type=template&id=46e1e94e&scoped=true&"
import script from "./PostPaid.vue?vue&type=script&lang=js&"
export * from "./PostPaid.vue?vue&type=script&lang=js&"
import style0 from "./PostPaid.vue?vue&type=style&index=0&id=46e1e94e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e1e94e",
  null
  
)

export default component.exports